module.exports = (time) => {
  /*
  ** 时间段相差的天数
  ** dateRange [];
  **/
  const startTime = Date.parse(new Date(time[0]));
  const endTime = Date.parse(new Date(time[1]));
  const day = ((endTime - startTime) / 1000 / 60 / 60 / 24) + 1;
  return -day;
};
